export enum RecurringInvoicesSortProperty {
  Date = 'createdAt',
  FirstInvoice = 'startDate',
}
